import React, { useState, useMemo, useEffect } from "react";
import CardPayrollTabUX from "./CardPayrollTabUX";
import CardPayrollRevenueAndDeductTab from "./CardPayrollRevenueAndDeductTab";
import CardPayrollSetting from "./CardPayrollSetting";
import CardPayrollSalaryTab from "./CardPayrollSalaryTab";
import { RunSequence, SetProp } from "./sequence/Payroll";
import { ADMIN_NAME_LIST, ADMIN_TAB_LIST } from "react-lib/apps/USER/CardSettingDivision";

type TabMenu = "SALARY" | "REVENUEANDDEDUCT" | "SETTING";

type CardPayrollProps = {
  onEvent: (e: any) => any;
  setProp: SetProp;
  runSequence: RunSequence;
  PayrollSequence: any;
  initialTab?: TabMenu;
  adminMenuDivisions: any;
  buttonLoadCheck?: any;
  errorMessage?: any;
  masterOptions: any;
  successMessage?: any;
  languageUX?: any;
};

const TAB_MENU_MAPPING = {
  // Salary
  [ADMIN_TAB_LIST["Salary"]]: "SALARY",
  // Revenue & Deduct
  [ADMIN_TAB_LIST["Revenue & Deduct"]]: "REVENUEANDDEDUCT",
  // Setting
  [ADMIN_TAB_LIST["Setting"]]: "SETTING",
} as const;

const CardPayroll = (props: CardPayrollProps) => {
  const [activeTab, setActiveTab] = useState<"" | TabMenu>("");
  console.log("Payroll props:", props);

  const filteredTabMenu = useMemo(() => {
    const tabs = props.adminMenuDivisions?.all[ADMIN_NAME_LIST["Payroll"]]?.tabs ?? [];

    return Object.entries(TAB_MENU_MAPPING)
      .filter(([key]) => tabs.includes(key))
      .map((menu) => menu[1]);
  }, [props.adminMenuDivisions]);

  useEffect(() => {
    props.runSequence({ sequence: "Payroll", restart: true });
  }, []);

  useEffect(() => {
    setActiveTab(props.initialTab || filteredTabMenu[0] || "");
  }, [filteredTabMenu, props.initialTab]);

  const handleChangeTab = (tab: TabMenu) => {
    if (tab === activeTab) return;
    setActiveTab(tab);
  };

  const settingColorTab = (tab: TabMenu): "blue" | undefined => {
    return activeTab === tab ? "blue" : undefined;
  };

  const displayTab = useMemo(() => {
    switch (activeTab) {
      case "SETTING":
        return <CardPayrollSetting {...props} />;
      case "REVENUEANDDEDUCT":
        return <CardPayrollRevenueAndDeductTab {...props} />;
      case "SALARY":
        return <CardPayrollSalaryTab {...props} />;

      default:
        return null;
    }
  }, [
    activeTab,
    props.buttonLoadCheck,
    props.PayrollSequence?.bankAccount,
    props.PayrollSequence?.province,
    props.PayrollSequence?.provinceList,
    props.PayrollSequence?.district,
    props.PayrollSequence?.districtList,
    props.PayrollSequence?.city,
    props.PayrollSequence?.cityList,
    props.PayrollSequence?.zipcode,
    props.PayrollSequence?.salaryPayRunList,
    props.PayrollSequence?.salaryPayRunParams,
    props.PayrollSequence?.employeePayrollList,
    props.PayrollSequence?.searchResultSummary,
    props.PayrollSequence?.searchResultEmployeePayrollList,
    props.PayrollSequence?.payrollSummaryParams,
    props.PayrollSequence?.revenueItems,
    props.PayrollSequence?.deductItems,
    props.PayrollSequence?.detailSetting,
    props.PayrollSequence?.userDetail,
    props.masterOptions?.positionAll,
    props.masterOptions?.division,
    props.languageUX,
  ]);

  return (
    <CardPayrollTabUX
      activeTab={activeTab}
      displayTab={displayTab}
      filteredTabMenu={filteredTabMenu}
      handleChangeRevenueTab={() => handleChangeTab("REVENUEANDDEDUCT")}
      handleChangeSalaryTab={() => handleChangeTab("SALARY")}
      handleChangeSettingTab={() => handleChangeTab("SETTING")}
      handleRevenueTabcolor={settingColorTab("REVENUEANDDEDUCT")}
      handleSalaryTabcolor={settingColorTab("SALARY")}
      handleSettingTabcolor={settingColorTab("SETTING")}
      languageUX={props.languageUX}
    />
  );
};

export default React.memo(CardPayroll);
